import React, { useEffect, useState } from 'react';
import SearchRow from 'components/SearchRow/SearchRow';
import Table from 'components/Table/Table';
import ChallengePage from './ChallengePage';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { get } from 'lib/comms';
import { Navigate, useLocation } from 'react-router-dom';
import SubscriptionBanner from 'components/SubscriptionBanner/SubscriptionBanner';
import ToolTip from 'components/ToolTip/TooltTip';

// export default class ChallengesPage extends React.Component {
const ChallengesPage = (props) => {
    const location = useLocation();

    const navigationState = location?.state;
    const previousPage = navigationState?.from;
    const fromAnotherPage = navigationState?.from === 'onboarding' || navigationState?.from === 'campaigns';

    const [state, setState] = useState({
        data: [],
        createdNew: false,
        stepIndex: 0,
        fromAnotherPage: false,
        editing: fromAnotherPage ? { id: 'new' } : null,
    });

    console.log('state');
    console.log(state);

    const columns = [
        {
            name: 'Name of the Challenge',
            grow: 7,
            // selector: 'name',
            selector: (row) => row.name,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Start date',
            grow: 2,
            selector: (row) => row.start_date,
            sortable: true,
            format: (row) => moment(row.start_date).format('DD MMM YYYY'),
        },
        {
            name: 'Participants',
            // selector: 'member_count',
            selector: (row) => row.member_count,
            sortable: true,
            center: true,
        },
        {
            name: 'Points value',
            grow: 2,
            // selector: 'effort_level',
            selector: (row) => row.effort_level,
            sortable: true,
            center: true,
            format: (row) => row.effort_level * 50,
        },
        {
            name: 'Status',
            // selector: 'active',
            selector: (row) => row.active,
            sortable: true,
            center: true,
            format: (row) => (row.active ? 'Active' : 'Archived'),
        },
        {
            name: '',
            // selector: 'id',
            selector: (row) => row.id,
            sortable: false,
            grow: 0,
            right: true,
            cell: () => <FontAwesomeIcon color="#999" icon={faChevronRight} />,
        },
    ];

    const reload = async () => {
        let resp = await get('cms/challenges', null, true);
        if (resp && resp.status === 401) setState({ ...state, logout: true });
        if (resp && resp.challenges) setState({ ...state, data: resp.challenges });
        else console.log(resp);
    };

    useEffect(() => {
        reload();
    }, [setState]);

    const updateItemCreated = () => {
        setState({ ...state, createdNew: true });
    };

    const doneEditing = () => {
        //  reload();
        if (fromAnotherPage) {
            setState({ ...state, fromAnotherPage: true });
        } else {
            setState({ ...state, editing: null });
        }
    };

    if (state.logout) return <Navigate to={{ pathname: '/logout', state: { from: props.location } }} />;
    if (state.fromAnotherPage) {
        return (
            <Navigate
                to={{
                    pathname: `/${previousPage}`,
                    state: { ...navigationState, from: 'challenges', createdNew: state.createdNew },
                }}
            />
        );
    }
    let { data, search, editing } = state;
    if (search) {
        data = data.filter((item) => `${item.name} ${item.category}`.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }
    return (
        <>
            {editing ? (
                <ChallengePage
                    challenge={editing}
                    onBack={doneEditing}
                    updateItemCreated={updateItemCreated}
                    reload={reload}
                />
            ) : (
                <div className="maincontainer">
                    <SubscriptionBanner />
                    <h4>Challenges</h4>
                    <SearchRow
                        value={search}
                        searchTitle="Search by challenge name"
                        buttonTitle="ADD NEW CHALLENGE"
                        onBtnClick={(item) => setState({ ...state, editing: { id: 'new' } })}
                        onSearch={(search) => setState({ ...state, search })}
                    />
                    <Table
                        columns={columns}
                        data={data}
                        onRowClicked={(item) => setState({ ...state, editing: item })}
                        tableID="challenges"
                        defaultSortField={columns[1].selector}
                    />
                </div>
            )}
            <ToolTip
                callback={(tooltipData) => {
                    if (tooltipData.lifecycle === 'complete') {
                        setState({
                            ...state,
                            stepIndex: tooltipData.action === 'prev' ? tooltipData.index - 1 : tooltipData.index + 1,
                            editing:
                                (state.stepIndex === 0 && tooltipData.action === 'next') ||
                                (state.stepIndex === 1 && tooltipData.action === 'next') ||
                                (state.stepIndex === 2 && tooltipData.action === 'prev')
                                    ? { id: 'new' }
                                    : null,
                        });
                    }
                }}
                screenId={'challenges'}
                steps={[
                    {
                        target: '.searchrow-btn',
                        title: 'Add New Challenge',
                        content:
                            'Challenges are a great way to get your users working towards a common goal without the need to all be in the same place at the same time. Select Add new challenge to get started.',
                    },
                    {
                        target: '.card',
                        title: 'Creating your challenge',
                        content:
                            'Give your challenge a title and add a description about this challenge. You can then choose the time period for this challenge to run, the start date will be the date the challenge becomes available in the engage tab in the app for users to find and join. You can then allocate the effort level which will also award points for when this challenge is complete. The last field is target this number which allows you to set how many times an activity must be done to complete this challenge.',
                    },
                    {
                        target: '.card-edit',
                        title: 'Saving and managing your challenge',
                        content:
                            'Once you select save you will see a list of any user who have joined the challenge or you can add users to this challenge. You will also see the option to delete the challenge which if selected will delete the challenge and any progress and can not be undone.',
                    },
                ]}
                stepIndex={state.stepIndex}
            />
        </>
    );
};

export default ChallengesPage;
